__turbopack_context__.v({
  "cardAnimation": "resources-module__yI52Kq__cardAnimation",
  "cardBorder": "resources-module__yI52Kq__cardBorder",
  "ctaAnimation": "resources-module__yI52Kq__ctaAnimation",
  "ctaBackground": "resources-module__yI52Kq__ctaBackground",
  "ctaBorder": "resources-module__yI52Kq__ctaBorder",
  "fadeInUp": "resources-module__yI52Kq__fadeInUp",
  "headerAnimation": "resources-module__yI52Kq__headerAnimation",
  "iconBackground": "resources-module__yI52Kq__iconBackground",
  "iconColor": "resources-module__yI52Kq__iconColor",
  "primaryButton": "resources-module__yI52Kq__primaryButton",
  "secondaryButton": "resources-module__yI52Kq__secondaryButton",
  "sectionAnimation": "resources-module__yI52Kq__sectionAnimation",
});
